import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Coaching from "@/pages/Coaching";
import ClientStories from "@/pages/ClientStories";
import Signature from "@/pages/Signature";
import { ChatAssistant } from "@/components/site/ChatAssistant";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const timer = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 100);
    return () => clearTimeout(timer);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/coaching" element={<Coaching />} />
        <Route path="/client-stories" element={<ClientStories />} />
        <Route path="/signature" element={<Signature />} />
      </Routes>
      <ChatAssistant />
      <Toaster position="bottom-left" />
    </BrowserRouter>
  );
}

export default App;
